import {
  AutocompleteField,
  FileInputField,
  InputField,
} from 'components/molecules/formFields';
import React, { useEffect, useMemo, useState } from 'react';
import { useMessage } from 'utils/hooks';

import { FormBuilder } from './form-builder';
import { MessageFormProps } from './types';

export const NewMessageForm = ({
  initValue,
  disableAll = false,
  onBack,
  onSubmit,
  disableSelect = false,
}: MessageFormProps) => {
  const [disableSubmit, setDisabledSubmit] = useState(false);
  const { patientGuardianMessageOptions } = useMessage();

  useEffect(() => setDisabledSubmit(disableAll), [disableAll]);

  const fields = [
    {
      component: InputField,
      fieldKey: 'message',
      label: 'MESSAGE',
      multiline: true,
      required: true,
      rows: 4,
      xs: 12,
    },
    {
      component: FileInputField,
      disable: disableSubmit,
      fieldKey: 'filename',
      label: 'ATTACH FILE',
      acceptFileType: 'application/pdf, image/*, video/mp4, video/webm, video/ogg',
      isUploadingFile: (uploading: boolean) => setDisabledSubmit(uploading),
      xs: 6,
    },
  ];

  const formFields = useMemo(() => {
    if (disableSelect) {
      return [
        {
          component: AutocompleteField,
          fieldKey: 'receiverId',
          label: 'TO',
          required: true,
          options: patientGuardianMessageOptions,
          placeholder: 'Search for Patient...',
          xs: 6,
        },
        ...fields,
      ];
    }
    return fields;
  }, [disableSelect]);

  return (
    <FormBuilder
      initValues={initValue}
      disableSubmit={disableSubmit}
      formFields={formFields}
      onBack={onBack}
      onSubmit={onSubmit}
    />
  );
};
